module.exports = __webpack_public_path__ + "static/TANMEMORIES-Regular-eaa388226d231836ec2d4d191d2714c6.woff2";